import React, {
  lazy, Suspense, useEffect, useState
} from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { Badge, Link, Typography } from '@one-thd/sui-atomic-components';
import { getDeliveryZip } from '../../helper/utils';
import { SimilarModelsLoading } from './SimilarModelsLoading';

const SimilarModels = lazy(() => import('./SimilarModels').then((mod) => ({ default: mod.SimilarModels })));

const MajorApplianceOutOfStock = ({ itemId, zipCode = null, onCheckAnotherZip }) => {
  const { storeZip } = useStore();
  const [mounted, setMounted] = useState(false);
  const deliveryZip = zipCode || getDeliveryZip() || storeZip;

  useEffect(() => {
    setMounted(true);
  }, []);

  const { data } = useDataModel('outOfStockProduct', {
    ssr: false,
    variables: { itemId }
  });
  const categoryHierarchy = data?.product?.taxonomy?.breadCrumbs?.map((breadCrumb) => breadCrumb?.label);

  return (
    <div
      className="sui-flex sui-flex-col sui-items-start sui-gap-3 sui-max-w-md"
      data-testid="fulfillment__unavailable"
      data-component="FulfillmentNotifyMe"
    >
      <span data-automation-id="fulfillment__out-of-stock">
        <Badge color="warning" variant="outline">Out of Stock</Badge>
      </span>
      <Typography variant="h4" weight="bold" height="tight">
        {deliveryZip ? `Not available in ZIP Code ${deliveryZip}` : 'Not available in your area'}
      </Typography>
      {mounted ? (
        <Suspense fallback={<SimilarModelsLoading />}>
          <SimilarModels itemId={itemId} zipCode={deliveryZip} categoryHierarchy={categoryHierarchy} />
        </Suspense>
      ) : (
        <SimilarModelsLoading />
      )}
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link component="button" onClick={onCheckAnotherZip}>Check another ZIP Code</Link>
    </div>
  );
};

MajorApplianceOutOfStock.propTypes = {
  itemId: PropTypes.string.isRequired,
  zipCode: PropTypes.string,
  onCheckAnotherZip: PropTypes.func.isRequired
};

MajorApplianceOutOfStock.displayName = 'MajorApplianceOutOfStock';

export { MajorApplianceOutOfStock };
